import { cn } from "@/utils/cn";
import { FC, ReactNode } from "react";
import { ComponentLabel } from ".";
import { StatusBadge, type StatusBadgeVariant } from "./";

export type ListBlockValueItem = string | { text: string; tag?: ReactNode };

interface ListBlockProps {
  label: string;
  theme?: StatusBadgeVariant;
  value: string | ListBlockValueItem[];
  sn: number;
}

export const ListBlock: FC<ListBlockProps> = ({ label, value, theme, sn }) => {
  return (
    <div
      className={cn(
        "flex flex-col gap-3 lg:min-w-[180px]",
        sn != 1 && "lg:max-w-[220px]",
      )}
    >
      <ComponentLabel text={label} />
      <div className="flex flex-col gap-2">
        {Array.isArray(value) ? (
          value.map((v, i) => {
            const text = typeof v === "string" ? v : v.text;
            const tag = typeof v === "string" ? undefined : v.tag;
            return (
              <div
                key={i + text}
                className="flex flex-wrap items-center gap-2 text-base leading-[22.4px] font-light tracking-[0.16px] text-[#323232] capitalize"
              >
                <span>{text}</span>
                {tag}
              </div>
            );
          })
        ) : theme ? (
          <StatusBadge text={value} variant={theme} />
        ) : (
          <div className="w-max text-base leading-[22.4px] font-light tracking-[0.16px] capitalize">
            {value}
          </div>
        )}
      </div>
    </div>
  );
};
